<svelte:options customElement={{tag: "ia-personcenterednursingreviewform"}}/>

<script>
    import dressing from "@intellectability/platform-common";
    import {
        CommonStyles,
        MainPreloader,
        Toast,
        VerifyUserAction,
        WipeCache
    } from "@intellectability/platform-common/sv";
    import {Router} from "@intellectability/platform-common/router";
    import {getApplicationConfig, isLoggedIn, setCompilationContext} from "@intellectability/platform-common/sv/state";
    import {onMount} from "svelte";
    import routerConfig from "../router.js";

    let styleLoading = $state(true);
    let checkingLogin = $state(true);
    let env_type = $derived(getApplicationConfig("node_env") || "");

    /*
     * Self-executing function that automatically performs developer login
     * when the application is running on localhost
     */
    onMount(async function () {
        if (!$isLoggedIn) {
            await dressing.api.do_dev_login();
        }
        setCompilationContext($host()?.shadowRoot ?? document);
        checkingLogin = false;
    });
</script>

<main class="wa-theme-matter wa-palette-mild wa-brand-purple wa-cloak mb-4">
    <!-- sets up the <link> elements for the component to import the common styles -->
    <CommonStyles
            env={env_type}
            onload={() => styleLoading = false}
            onerror={() => styleLoading = false}
    />
    {#if styleLoading || checkingLogin}
        <!-- show a preload spinner while styles are loading to prevent "FOUC" -->
        <MainPreloader></MainPreloader>
    {:else}
        <!-- render the router component with the imported local config for this stitch -->
        <Router {routerConfig}></Router>
        <Toast/>
        <VerifyUserAction/>
        <WipeCache showButton></WipeCache>
    {/if}
</main>